// Custom cursor
const cursor = document.getElementById('cursor');
const ring = document.getElementById('cursorRing');

if (cursor && ring) {
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
    setTimeout(() => {
      ring.style.left = e.clientX + 'px';
      ring.style.top = e.clientY + 'px';
    }, 60);
  });

  document.querySelectorAll('a, button, .thumb, .qty-btn').forEach(el => {
    el.addEventListener('mouseenter', () => ring.classList.add('hovered'));
    el.addEventListener('mouseleave', () => ring.classList.remove('hovered'));
  });
}

// Quantity control
function changeQty(delta) {
  const el = document.getElementById('qty');
  const input = document.getElementById('qty-input');
  if (!el) return;
  const val = Math.max(1, parseInt(el.textContent) + delta);
  el.textContent = val;
  if (input) input.value = val;
}

// Scroll reveal
const revealEls = document.querySelectorAll('.reveal');
const io = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
  });
}, { threshold: 0.12 });
revealEls.forEach(el => io.observe(el));

// Parallax hero
window.addEventListener('scroll', () => {
  const lines = document.querySelector('.hero-lines');
  if (lines) lines.style.transform = `translateY(${window.scrollY * 0.3}px)`;
});

// Cart AJAX add
const productForm = document.getElementById('product-form');
if (productForm) {
  productForm.addEventListener('submit', async function(e) {
    e.preventDefault();
    const btn = this.querySelector('[name="add"]');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    const formData = new FormData(this);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      if (res.ok) {
        btn.textContent = '✓ Added!';
        btn.style.background = '#4CAF50';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
          updateCartCount();
        }, 2000);
      } else {
        btn.textContent = 'Try Again';
        btn.disabled = false;
      }
    } catch (err) {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.querySelector('.cart-count');
    if (cart.item_count > 0) {
      if (badge) {
        badge.textContent = cart.item_count;
      } else {
        const cartIcon = document.querySelector('.cart-icon');
        if (cartIcon) {
          const span = document.createElement('span');
          span.className = 'cart-count';
          span.textContent = cart.item_count;
          cartIcon.appendChild(span);
        }
      }
    }
  } catch (e) {}
}
